import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useUpgradePointTooltipData } from './useUpgradePointTooltipData';
import { jsx as _jsx } from "react/jsx-runtime";
export const UpgradePointTooltip = ({
  upgradeKey,
  enableTooltip = true,
  children
}) => {
  const tooltipData = useUpgradePointTooltipData(upgradeKey, enableTooltip);
  if (tooltipData.data.hasError) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    onOpenChange: tooltipData.onOpenChange,
    Content: tooltipData.Content,
    disabled: tooltipData.disabled,
    children: children
  });
};